export enum IdfAccordionKind {
  PLUS = 'plus',
  CARET = 'caret',
}
